import * as tslib_1 from "tslib";
import { throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { BaseService } from '../base.service';
import { OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
var VirtualGoodsInventoryService = /** @class */ (function (_super) {
    tslib_1.__extends(VirtualGoodsInventoryService, _super);
    function VirtualGoodsInventoryService(http) {
        var _this = _super.call(this, 'virtual-good-inventory', http) || this;
        _this.http = http;
        return _this;
    }
    VirtualGoodsInventoryService.prototype.ngOnInit = function () {
    };
    VirtualGoodsInventoryService.prototype.getAllVirtualGoodsInventoryByPaging = function (searchCondition, paging) {
        if (!searchCondition) {
            searchCondition = '';
        }
        // const sortStr = sortOprions.getSortString();
        return this.http.get(this.url + "?" + ("" + paging.getPagingStr() + (this.embeddedStr + searchCondition) + "&sort=id,desc")).pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    VirtualGoodsInventoryService.prototype.getAllByBusinessIdByPaging = function (searchCondition, businessId, paging) {
        if (!searchCondition) {
            searchCondition = '';
        }
        return this.http.get(this.url + "?" + paging.getPagingStr() + (this.embeddedStr + searchCondition) + "&sort=id,desc" + (businessId ? "&f_businessId=" + businessId + "&f_businessId_op==" : '')).pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    VirtualGoodsInventoryService.prototype.getAllByWalletIdsByPaging = function (walletIds, searchCondition, paging) {
        var sortStr = '&sort=id,asc';
        var walletIdsStr = '';
        if (walletIds) {
            walletIds.forEach(function (id) {
                walletIdsStr += "&f_acceptedMerchants=" + id;
            });
        }
        if (walletIdsStr) {
            walletIdsStr += '&f_acceptedMerchants_op=IN';
        }
        return this.http.get(this.url + "?" + paging.getPagingStr() + walletIdsStr + sortStr + searchCondition).pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    VirtualGoodsInventoryService.prototype.publishCouponById = function (id) {
        return this.http.post(this.url + "/" + id + "/dispatch", '').pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    return VirtualGoodsInventoryService;
}(BaseService));
export { VirtualGoodsInventoryService };
